import Decimal from 'decimal.js';
import { useIntl } from 'react-intl';

import { Icon } from '../../components/icons/Icon';
import { Slider } from './Slider';
import { t } from '../utils/translate';
import styles from './InputRow.module.less';

interface Props {
  value: string;
  collateralBig: Decimal;
  minBtc: Decimal;
  midBtc: Decimal;
  maxBtc: Decimal;
  onValueChange: (raw: string) => void;
  onBlur: () => void;
  onSliderChange: (next: Decimal) => void;
}

export function CollateralRow({
  value,
  collateralBig,
  minBtc,
  midBtc,
  maxBtc,
  onValueChange,
  onBlur,
  onSliderChange,
}: Props) {
  const intl = useIntl();

  return (
    <div className={styles.row}>
      <label className={styles.label}>
        {t(intl, 'calculator.collateralBtc')}
      </label>
      <div className={styles.innerRow}>
        <div className={styles.inputWrap}>
          <input
            type="text"
            inputMode="decimal"
            className={styles.amountInput}
            value={value}
            onChange={e => onValueChange(e.target.value)}
            onBlur={onBlur}
            aria-label={t(intl, 'calculator.collateralBtc')}
          />
          <span className={styles.suffix}>
            <Icon className={styles.suffixFlag} type="btc" aria-hidden />
            <span className={styles.suffixCode}>BTC</span>
          </span>
        </div>
        <Slider
          value={collateralBig}
          min={minBtc}
          mid={midBtc}
          max={maxBtc}
          ariaLabel={t(intl, 'calculator.collateralBtcSlider')}
          decimals={8}
          onValueChange={onSliderChange}
        />
      </div>
    </div>
  );
}
